import { render, staticRenderFns } from "./BillsOfRetailer.vue?vue&type=template&id=b5198daa"
import script from "./BillsOfRetailer.vue?vue&type=script&lang=js"
export * from "./BillsOfRetailer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports